const SelectDropdown = ({
  id = "",
  label = "",
  dropdownClass = "",
  wrapperClassName = "",
  selectClassName = "",
  labelClass = "",
  dropdownData = [],
  value = "",
  select = () => {},
  blur = () => {},
  touch = () => {},
  optionId = "",
  optionLabel = "",
  prefixLabel = "",
  disabled = false,
  ariaLabel = "",
  defaultOption = "",
  defaultOptionLabel = "--select--",
  error = false,
  touched = false,
  errorClassName = "",
}) => {
  function selectedValue(e) {
    select(e.target.value);
  }
  function blurValue(e) {
    blur(e.target.value);
  }
  return (
    <div className={`form-group selectDropdown ${wrapperClassName}`}>
      {label ? (
        <label className={`${labelClass} mb-1`} htmlFor={id}>
          {label}
        </label>
      ) : (
        ""
      )}
      <div className={`${dropdownClass}`}>
        <select
          id={id}
          className={`form-control form-select ${
            selectClassName ? selectClassName : "w-auto"
          } ${error && touched && "is-invalid"}`}
          onChange={selectedValue}
          onBlur={blurValue}
          onFocus={touch}
          value={value}
          disabled={disabled}
          aria-label={ariaLabel}
        >
          {defaultOption && <option value="">{defaultOptionLabel}</option>}
          {dropdownData.map((e, index) => {
            return (
              <option
                value={optionId || e.id ? e[optionId] || e.id : e}
                key={e[optionId] || index}
              >
                {prefixLabel && e[prefixLabel] ? e[prefixLabel] + " - " : ""}
                {optionLabel || e.name ? e[optionLabel] || e.name : e}
              </option>
            );
          })}
        </select>
        {error && touched && (
          <span className={`invalid-feedback ${errorClassName}`}>{error}</span>
        )}
      </div>
    </div>
  );
};

export default SelectDropdown;
